import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Guid, Utility } from '../core/common';
import { PushService } from './push.service';
import html2canvas from 'html2canvas';
import { SwUpdate } from '@angular/service-worker';
import { Store } from '@ngxs/store';
import { AuthState } from '../states/auth.state';
import { BehaviorSubject, Observable, Subject, firstValueFrom, map, of, takeUntil, tap } from 'rxjs';
import { SharedService } from './shared.service';
import { cachedObservable } from '../core/cached-observable';
import { AnalyticsService } from './analytics.service';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  commands = [
    { Script: 'refresh', Title: 'بروزرسانی نرم‌افزار' },
    { Script: 'client-info', Title: 'دریافت اطلاعات مرورگر' },
    { Script: 'screenshot', Title: 'گرفتن تصویر صفحه' }
  ];

  constructor(private http: HttpClient, private swUpdate: SwUpdate,
    private pushService: PushService, private analytics: AnalyticsService,
    private sharedService: SharedService, private store: Store) {
    if (!sharedService.isBrowser) return;
    ChatService.current = this.store.selectSnapshot(state => state.auth.user);
    AuthState.user$.pipe(takeUntil(this.unsubscribe$)).subscribe(async user => {
      if (!user) {
        ChatService.stats$.next(null);
        return;
      }
      // interval(10 * 60 * 1000).pipe(takeUntil(this.unsubscribe$)).subscribe(() => this.getStats());
      await this.fetchStats();
      // this.contacts$.subscribe(contacts => {
      //   if (contacts?.length)
      //     this.getParticipants(...(contacts.map(_ => _.Id))).subscribe();
      // });
    });
    this.pushService.onMessage$<any>('stats').pipe(takeUntil(this.unsubscribe$))
      .subscribe(stats => {
        // console.log(stats);
        ChatService.stats$.next(Utility.assign(ChatService.stats$.value || {}, Utility.removeNull(stats)));
      });

    ChatService.stats$.subscribe(stats => {
      var badge = !stats?.UnreadChats ? null
        : Object.getOwnPropertyNames(stats.UnreadChats).filter(_ => stats.UnreadChats[_] > 0).length;
      sharedService.badge(badge, { bgColor: '#317bf2' });
    });
  }

  private unsubscribe$ = new Subject<void>();
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  static current: any;
  static stats$ = new BehaviorSubject<ChatStats>(null);

  async fetchStats(dump_cahce?: number) {
    ChatService.stats$.next(await firstValueFrom(this.http.get<any>(environment.app.apiUrl + 'chat/stats', {
      params: dump_cahce ? { cache: dump_cahce } : undefined
    })));
  }
  static get dueTodoCount() {
    if (!ChatService.stats$.value?.DueTodos) return null;
    var result = 0;
    Object.getOwnPropertyNames(ChatService.stats$.value.DueTodos).forEach(_ => result += ChatService.stats$.value?.DueTodos[_] || 0);
    return result;
  }
  static get unreadChatCount() {
    if (!ChatService.stats$.value?.UnreadChats) return null;
    return Object.getOwnPropertyNames(ChatService.stats$.value.UnreadChats).filter(_ => ChatService.stats$.value.UnreadChats[_] > 0).length;
  }
  static isMe(data: any) {
    var identifiers = this.stats$.value?.Participant?.Identifiers || [ChatService.current?.Id];
    if (!data || !identifiers?.length) return false;
    if (typeof data == 'string')
      return !!identifiers?.includes(data);
    else if (Array.isArray(data))
      return !!data.find(_ => identifiers?.includes(_));
  }

  listenCommands() {
    this.pushService.onMessage$<any>('command')
      .subscribe(command =>
        setTimeout(async () => {
          if (command.Result) return;
          switch (command.Script) {
            case 'refresh':
              this.swUpdate.activateUpdate()
                .then(async updated => {
                  await this.commandResult(command.Id, {
                    'updated': updated,
                    'app-version': environment.app.version,
                  });
                  document.location.reload();
                }).catch(async ex => {
                  await this.commandResult(command.Id, {
                    'error': ex.message,
                    'stack': ex.stack,
                    'app-version': environment.app.version,
                  });
                  document.location.reload();
                });
              break;
            case 'client-info':
              await this.commandResult(command.Id, {
                'user-agent': navigator.userAgent,
                'app-version': environment.app.version,
                'sw-enabled': this.swUpdate.isEnabled,
              });
              break;
            case 'screenshot':
              html2canvas(document.body, { logging: false })
                .then(async canvas => {
                  canvas.toBlob(async blob => {
                    await this.commandResult(command.Id, {
                      url: location.href
                    }, blob);
                  }, 'image/jpeg');
                });
              break;
          }
        }));
  }

  getChat(chatId: string) {
    return this.http.get<any>(environment.app.apiUrl + `chat/get/${chatId}`).toPromise();
  }
  list(criteria?: any) {
    return this.http.post<any>(environment.app.apiUrl + `chat/list`, criteria || {});
  }
  folder(folder: string) {
    return this.http.get<any>(environment.app.apiUrl + `chat/folder/${folder}`);
  }

  listAdmin(criteria: any) {
    return this.http.post<any>(environment.app.apiUrl + `chat/list/admin`, criteria).toPromise();
  }

  getReplyThread(communicationId: string, branch: 'this' | 'parent' | 'children' | 'all' = 'this', after?: any, limit?: number, dump_cahce?: string) {
    return this.http.get<any>(environment.app.apiUrl + `chat/thread/${communicationId}/${branch}`, {
      params: Utility.removeEmpty({
        after: Utility.projectObject(after, ['Id', 'Timestamp', 'Asc'], true),
        limit,
        cahce: dump_cahce
      })
    });
  }
  communications(chatId?: string, after?: any, limit?: number, cahce_bust?: string) {
    return this.http.get<any>(environment.app.apiUrl + `chat/communications${chatId ? '/' + chatId : ''}`, {
      params: Utility.removeEmpty({
        after: Utility.projectObject(after, ['Id', 'Timestamp', 'Asc'], true),
        limit,
        cahce: cahce_bust
      })
    });
  }

  private static getCommunicationBucket: string[] = [];
  private static getCommunicationTimeout: any;
  getCommunication(communicationId: string) {
    if (!ChatService.getCommunicationBucket.includes(communicationId))
      ChatService.getCommunicationBucket.push(communicationId);

    return new Promise<any>(resolve => {
      clearTimeout(ChatService.getCommunicationTimeout);
      ChatService.getCommunicationTimeout = setTimeout(() => {
        var communicationIds = ChatService.getCommunicationBucket;
        ChatService.getCommunicationBucket = [];
        this.http.post<any[]>(environment.app.apiUrl + `chat/communication`, communicationIds).toPromise()
          .then(comms => resolve(comms.find(_ => _.Id == communicationId)));
      }, 1000);
    });
  }

  deleteCommunication(communicationId: string) {
    return firstValueFrom(this.http.delete(environment.app.apiUrl + `chat/communication/${communicationId}`));
  }
  searchCommunications(criteria: any, after?: any, limit?: number) {
    return this.http.post<any>(environment.app.apiUrl + `chat/communications/search`, criteria, {
      params: Utility.removeEmpty({ after: Utility.projectObject(after, ['Id', 'Timestamp', 'Asc'], true), limit })
    });
  }

  commandResult(commandId: string, result: any, ...attachment: Blob[]) {
    const body = this.addAttachments(attachment);
    body.append('result', JSON.stringify(result));
    return this.http.post<string>(environment.app.apiUrl + `chat/command/${commandId}`, body).toPromise();
  }

  addParticipant(chatId: string, ...userIdentifier: string[]) {
    return this.http.post<string>(environment.app.apiUrl + `chat/participant/${chatId}`, userIdentifier).toPromise();
  }

  saveChat(chat: any) {
    return this.http.post<string>(environment.app.apiUrl + `chat/save`, chat).toPromise();
  }

  contacts$ = cachedObservable<any[]>(this.http, 'chat-service', 'contacts',
    environment.app.apiUrl + `chat/contacts`, this.sharedService.log
  );
  hashtags$ = cachedObservable<string[]>(this.http, 'chat-service', 'hashtags',
    environment.app.apiUrl + `chat/hashtags`, this.sharedService.log
  );

  getPrivateChatId(contactId: string) {
    return this.http.get<string>(environment.app.apiUrl + `chat/private/${contactId}`).toPromise();
  }

  saveSettings(type: string, settings?: any) {
    return this.http.post<any>(environment.app.apiUrl + `chat/settings/${type}`, settings).toPromise();
  }
  getSettings(type: string): any {
    return this.http.get<any>(environment.app.apiUrl + `chat/settings/${type}`).toPromise();
  }

  send(communication: any, attachments?: Blob[], chat?: any) {
    const body = this.addAttachments(attachments);
    body.append('communication', JSON.stringify(communication));
    return this.http.post<string>(environment.app.apiUrl + `chat/send/${communication.Type}`, body, {
      params: Utility.removeNull({ chat: JSON.stringify(chat) })
    }).toPromise();
  }

  read(chatId: string, ...communicationId: string[]) {
    return this.http.post<string[]>(environment.app.apiUrl + `chat/read${chatId ? '/' + chatId : ''}`, communicationId).toPromise();
  }
  react(communicationId: string, reaction?: string) {
    return this.http.post<string[]>(environment.app.apiUrl + `chat/react/${communicationId}`, { reaction: reaction }).toPromise();
  }

  attachment(communicationId: string, attachmentId: string) {
    return this.http.get<Blob>(environment.app.apiUrl + `chat/attachment/${communicationId}/${attachmentId}`).toPromise();
  }

  private addAttachments(attachment: Blob[]) {
    const body = new FormData();
    for (let i = 0; i < attachment?.length; i++)
      body.append(`attachment_${i}`, attachment[i]);
    return body;
  }

  private static participantsPromiseCache: { [key: string]: Promise<string> } = {};
  private static participantsCache: { [key: string]: any } = {};
  private static getParticipantBucket: string[] = [];
  private static getParticipantTimeout: any;
  getParticipant(id: string) {
    if (!ChatService.participantsPromiseCache[id])
      ChatService.participantsPromiseCache[id] = new Promise<any>(resolve => {
        ChatService.participantsCache[id] = resolve;
        clearTimeout(ChatService.getParticipantTimeout);
        ChatService.getParticipantTimeout = setTimeout(() => {
          var ids = ChatService.getParticipantBucket;
          ChatService.getParticipantBucket = [];
          this.http.post<any[]>(environment.app.apiUrl + `chat/participants`, ids).toPromise()
            .then(result => {
              for (let _id in result)
                ChatService.participantsCache[_id](result[_id]);
            });
        }, 1000);
      });

    if (!ChatService.getParticipantBucket)
      ChatService.getParticipantBucket = [];
    if (!ChatService.getParticipantBucket.includes(id))
      ChatService.getParticipantBucket.push(id);

    return ChatService.participantsPromiseCache[id];
  }

  // private participants = new Map<string, Observable<any>>();
  // getParticipant(id: string): Observable<any> {
  //   if (this.participants.has(id))
  //     return this.participants.get(id);
  //   return this.getParticipants(id).pipe(map(_ => _[0]));
  // }
  // getParticipants(...ids: string[]) {
  //   return this.http.post<any[]>(environment.app.apiUrl + `chat/participants`, ids)
  //     .pipe(tap(_ => _.forEach(p => this.participants.set(p.Id, of(p)))));
  // }
  callSearch(criteria: any, from = 0, limit = 20) {
    return this.http.post<any>(environment.app.apiUrl + `chat/call/search/${from}/${limit}`, criteria).toPromise();
  }

  callReport_old(criteria: any, interval: string) {
    return this.http.post<any>(environment.app.apiUrl + `chat/call/report/old/${interval}`, criteria).toPromise();
  }

  callReport(query: any) {
    return this.http.post<any>(environment.app.apiUrl + `chat/call/report`, query).toPromise();
  }

  karpashaActionReport(query: any) {
    return this.http.post<any>(environment.app.apiUrl + `chat/karpasha-action-report`, query).toPromise();
  }

  logEvent(event: { category: string, action: string, label: string, data?: any }) {
    setTimeout(() => this.analytics.gtmEvent(event.action, event.category, event.label), 0);
    return this.http.post(environment.app.apiUrl + `chat/log-event`, event).toPromise();
  }

}

export class Communication {
  Id?: string = Guid.newGuid();
  Type?: string;
  Restricted?: boolean;
  ChatId?: string;
  Sender?: string;
  Timestamp?: Date;
  ReplyTo?: string;
  ForwardFrom?: string;
  Read?: string[];
  Reaction?: { [userId: string]: string };
  Attachments?: ChatAttachment[];
  Deleted?: boolean;
  InnerText?: string;
  Summary?: {
    Id?: string;
    Timestamp?: Date;
    Sender?: string;
    Type?: string;
    Text?: string;
  }
  Hashtags?: string[];
}

export class ChatAttachment {
  Id = Guid.newGuid();
  Name?: string;
  Type?: string;
  Size?: number;
  Extension?: string;
  Thumbnail?: string;
}

export class ChatStats {
  Participant?: any;
  UnreadChats?: { [key: string]: number };
  DueTodos?: { [key: string]: number };
};
